import React from 'react';
import { scheduleStringToGrid, gridToScheduleString } from '../utils/weeklySchedule';

// Sunday-first, matching the backend's day-major ordering (index 0 = Sunday).
const DAY_LABELS = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];
const HOURS = Array.from({ length: 24 }, (_, h) => h);

const WeeklyScheduleGrid = ({ value, onChange, disabled }) => {
  const grid = scheduleStringToGrid(value);

  const toggleCell = (day, hour) => {
    if (disabled) return;
    const next = grid.map((row) => [...row]);
    next[day][hour] = !next[day][hour];
    onChange(gridToScheduleString(next));
  };

  const fillAll = (filled) => {
    if (disabled) return;
    const next = Array.from({ length: 7 }, () => Array(24).fill(filled));
    onChange(gridToScheduleString(next));
  };

  return (
    <div>
      <div className="flex items-center gap-2 mb-2">
        <button
          type="button"
          disabled={disabled}
          onClick={() => fillAll(true)}
          className={`text-xs font-medium text-blue-600 hover:underline ${disabled ? 'opacity-60 cursor-not-allowed' : ''}`}
        >
          Seleccionar todo
        </button>
        <span className="text-gray-300">|</span>
        <button
          type="button"
          disabled={disabled}
          onClick={() => fillAll(false)}
          className={`text-xs font-medium text-blue-600 hover:underline ${disabled ? 'opacity-60 cursor-not-allowed' : ''}`}
        >
          Limpiar
        </button>
      </div>

      <div className="overflow-x-auto">
        <table className="border-collapse">
          <thead>
            <tr>
              <th className="w-8" />
              {HOURS.map((hour) => (
                <th key={`hour-${hour}`} className="text-[10px] font-normal text-gray-400 px-0.5">
                  {hour % 3 === 0 ? hour : ''}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {DAY_LABELS.map((dayLabel, day) => (
              <tr key={dayLabel}>
                <td className="text-xs text-gray-500 pr-1">{dayLabel}</td>
                {HOURS.map((hour) => {
                  const isOn = grid[day][hour];
                  return (
                    <td key={`${day}-${hour}`} className="p-[1px]">
                      <button
                        type="button"
                        data-testid={`schedule-cell-${day}-${hour}`}
                        aria-label={`${dayLabel} ${String(hour).padStart(2, '0')}:00`}
                        aria-pressed={isOn}
                        disabled={disabled}
                        onClick={() => toggleCell(day, hour)}
                        className={`w-3.5 h-3.5 rounded-sm border transition-colors ${
                          isOn ? 'bg-blue-600 border-blue-600' : 'bg-white border-gray-200'
                        } ${disabled ? 'cursor-not-allowed opacity-60' : 'hover:border-blue-400'}`}
                      />
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default WeeklyScheduleGrid;
